<template>
  <div id="app-container">
    <!-- 头部导航 -->
    <header-nav v-if="$route.meta.keepAlive" class="sidebar"></header-nav>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 标签页 -->
      <div v-show="tabs.length > 0" class="custom-tabs-container">
        <el-tabs
          v-if="$route.meta.keepAlive"
          v-model="activeTab"
          type="border-card"
          editable
          class="custom-tabs"
          @edit="handleTabsEdit"
          @tab-click="clickTab"
        >
          <el-tab-pane
            v-for="item in tabs"
            :key="item.path"
            :label="item.title"
            :name="item.path"
            :closable="tabs.length > 1"
          >
            <!-- 路由视图放在标签内容里 -->
            <keep-alive :include="cachedViews" >
              <router-view
                  v-if="activeTab === item.path"
                  :key="$route.fullPath"
                  class="tab-content-view"
              >
              </router-view>
            </keep-alive>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 非 keep-alive 路由 -->
      <router-view v-if="!$route.meta.keepAlive" class="content-view"></router-view>
    </div>
  </div>
</template>

<script>
import HeaderNav from './components/home/Header.vue'

export default {
  name: 'App',
  
  components: {
    HeaderNav
  },
  
  data() {
    return {
      activeTab: '', // 激活的标签
      tabs: [], // 所有标签
      tabIndex: 2,
      cachedViews: [] // 缓存的页面组件名称列表
    }
  },
  
  created() {
    // 初始化时添加当前路由
  },
  
  beforeDestroy() {
    // 清理
  },
  
  watch: {
    $route: {
      handler(to, from) {
        this.addTab(to)
      },
      immediate: true
    }
  },
  
  methods: {
    /**
     * 添加标签页
     */
    addTab(route) {
      console.log('当前标签页:', this.tabs)
      console.log('路由路径:', route.path)
      
      const existingTab = this.tabs.find(item => item.path === route.path)
      
      if (!existingTab) {
        // 新增标签
        if (route.meta.title) {
          this.tabs.push({
            title: route.meta.title,
            path: route.path,
            history: [route.fullPath]
          })
          
          // 添加到缓存列表
          const compName = route.meta.componentName || route.name
          if (compName && !this.cachedViews.includes(compName)) {
            this.cachedViews.push(compName)
          }
        }
      } else {
        // 已存在标签，记录历史
        existingTab.history.push(route.fullPath)
      }
      
      this.activeTab = route.path
    },
    
    /**
     * 处理标签页编辑（添加/删除）
     */
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        console.log('添加标签')
        return
      }
      
      if (action === 'remove') {
        this.removeTab(targetName)
      }
    },
    
    /**
     * 删除标签页
     */
    removeTab(targetName) {
      const tabs = this.tabs
      let activeName = this.activeTab
      
      // 如果关闭的是当前激活的标签，需要切换到其他标签
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.path === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.path
            }
          }
        })
      }
      
      // 更新激活标签
      this.activeTab = activeName
      
      // 跳转到激活的标签
      if (this.activeTab) {
        this.$router.push(this.activeTab)
      }
      
      // 从标签列表中移除
      this.tabs = tabs.filter(tab => tab.path !== targetName)
      
      // 从缓存列表中移除
      const removedTab = tabs.find(tab => tab.path === targetName)
      if (removedTab) {
        const compName = removedTab.path
        const cacheIndex = this.cachedViews.indexOf(compName)
        if (cacheIndex > -1) {
          this.cachedViews.splice(cacheIndex, 1)
        }
      }
    },
    
    /**
     * 点击标签页切换
     */
    clickTab(tab) {
      console.log('切换到标签:', this.tabs[tab.index].path)
      if (this.$route.path === this.tabs[tab.index].path) {
        return
      }
      this.$router.push(this.tabs[tab.index].path)
    }
  },
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #1f2329;
  letter-spacing: 0;
}

#app-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  background: url("https://p3-oe-bp.byteimg.com/tos-cn-i-0aqtudv0qh/dce7327a565c523523d8ac2b8a43b316.png~tplv-0aqtudv0qh-image.image") no-repeat;
  background-size: cover;
  overflow: hidden;
}

/* 侧边栏 */
.sidebar {
  flex-shrink: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 隐藏侧边栏滚动条但保持滚动功能 */
.sidebar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* 主内容区 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100vh;
  overflow: hidden;
}

.custom-tabs-container {
  flex: 1;
  min-height: 0;
  background: #fff;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 卡片化标签样式 */
.custom-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.custom-tabs ::v-deep .el-tabs--border-card {
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.custom-tabs ::v-deep .el-tabs__header {
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 0;
}

/* 标签项样式 */
.custom-tabs ::v-deep .el-tabs__item {
  height: 25px;
  line-height: 40px;
  font-size: 14px;
  color: #606266;
  background: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  border-bottom: none;
  padding: 0 16px;
  transition: all 0.3s;
}

.custom-tabs ::v-deep .el-tabs__item:hover {
  color: #409EFF;
}

.custom-tabs ::v-deep .el-tabs__item.is-active {
  color: #409EFF;
  background: #fff;
  font-weight: 500;
  border-bottom: 1px solid #fff;
}

/* 关闭按钮样式 */
.custom-tabs ::v-deep .el-tabs__item .el-icon-close {
  color: #909399;
  font-size: 12px;
  margin-left: 6px;
}

.custom-tabs ::v-deep .el-tabs__item .el-icon-close:hover {
  color: #f56c6c;
}

/* 内容区样式 */
.custom-tabs ::v-deep .el-tabs__content {
  padding: 0;
  overflow: visible;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* el-tab-pane 需要允许内容撑开 */
.custom-tabs ::v-deep .el-tab-pane {
  display: block;
  overflow: visible;
}

/* 标签内容视图 - 滚动容器 */
.tab-content-view {
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  background: #f5f7fa;
}

/* 自定义滚动条样式 */
.tab-content-view::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.tab-content-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.tab-content-view::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
  transition: background 0.3s;
}

.tab-content-view::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.content-view {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  background: #f5f7fa;
}

/* 非标签页内容滚动条样式 */
.content-view::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.content-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.content-view::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
  transition: background 0.3s;
}

.content-view::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 内容区域标题 */
.content-header {
  background: #e8f0fe;
  padding: 16px 20px 16px 20px;
  border-bottom: 1px solid #d0e0f0;
  flex-shrink: 0;
}

.content-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2329;
  line-height: 1.4;
}

#app {
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

button,
input,
textarea,
select {
  font-family: inherit;
}

table {
  table-layout: fixed;
}

.custom-tabs .el-tabs__nav-scroll {
  /* 自定义样式 */
}

/* 修复日期范围选择器"至"字被遮挡的问题 - 全局样式 */
.el-date-editor.el-range-editor {
  width: auto !important;
}

.el-range-editor .el-range-input {
  width: 38% !important;
}

.el-range-editor .el-range-separator {
  width: 24% !important;
  padding: 0 2px;
  line-height: 32px;
  text-align: center;
}

/* 针对 mini 尺寸的选择器 */
.el-range-editor--mini .el-range-separator {
  line-height: 28px;
}

/* 针对 small 尺寸的选择器 */
.el-range-editor--small .el-range-separator {
  line-height: 32px;
}

/* 针对 default 尺寸的选择器 */
.el-range-editor--default .el-range-separator {
  line-height: 40px;
}
</style>
